module.exports = __webpack_public_path__ + "static/media/planta2.b10e4e6b.png";